const CONSENT_KEY = "daroma_cookie_consent";
const CONSENT_DAYS = 365;

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveConsent(prefs) {
  const data = { ...prefs, savedAt: Date.now() };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(data));
  const expires = new Date(Date.now() + CONSENT_DAYS * 864e5).toUTCString();
  document.cookie =
    `${CONSENT_KEY}=${encodeURIComponent(JSON.stringify(data))}` +
    `; expires=${expires}; path=/; SameSite=Lax`;
}

export function acceptAll() {
  saveConsent({ technical: true, analytics: true, personalization: true });
}

export function rejectNonEssential() {
  saveConsent({ technical: true, analytics: false, personalization: false });
}
